import React, { useState, useEffect } from "react";
import styles from "./DiscountPart.module.css";
import { useFetchWithToken } from "../FetchWithToken/FetchWithToken";
import { toast } from "react-toastify";
import { apiUrl } from "../../Constants/Constants";
import CtaBtns from "../CtaBtns/CtaBtns.module";
import LoadingCircl from "../LoadingCircl/LoadingCircl.module";
import Loading from "../Loading/Loading.module";
const DiscountPart = ({
  setFinalPrice,
  accounts,
  totalPrice,
  formatPrice,
  discountCode,
  setDiscountCode,
  setChangeAllowed,
  changeAllowed,
}) => {
  const [dataReturned, setDataRetuened] = useState(null);

  useEffect(() => {
    setFinalPrice(totalPrice);
  }, []);
  const { loading, fetchWithToken } = useFetchWithToken();
  const discountReview = () => {
    const former = new FormData();
    former.append("selectedAccounts", accounts);
    former.append("discountCode", discountCode);

    fetchWithToken(
      apiUrl + "user/discount-review-renew",
      { method: "POST" },
      former
    ).then((data) => {
      if (data.status === "200") {
        setDataRetuened(data?.data);
        setChangeAllowed(false);
        toast.success("تخفیف با موفقیت اعمال شد.");
        setFinalPrice(data?.data?.finalPrice);
      } else {
        toast.error(data.data.message);
      }
    });
  };
  return (
    <div>
      <div className={styles.inputForDiscount}>
        <input
          className={styles.textIn}
          placeholder="کد تخفیف دارید؟"
          type="text"
          disabled={!changeAllowed}
          onChange={(e) => setDiscountCode(e.target.value)}
        />
        <div className={styles.ctBtn}>
          <CtaBtns
            disabled={!changeAllowed}
            onAtion={() => changeAllowed && discountReview()}
          >
            اعمال
          </CtaBtns>
        </div>
      </div>
      {loading && <Loading />}
      {changeAllowed ? (
        <p>مجموع مبلغ قابل پرداخت: {formatPrice(totalPrice)}</p>
      ) : (
        <>
          <p className={styles.bolder}>
            تخفیف : {dataReturned?.value}
            {dataReturned.type == "Percent" ? "%" : " تومان"}
          </p>

          <p>
            مجموع مبلغ قابل پرداخت:
            <span className={styles.beforePrice}>
              {formatPrice(dataReturned.originalPrice)}
            </span>
            {formatPrice(dataReturned.finalPrice)}
          </p>
        </>
      )}
    </div>
  );
};

export default DiscountPart;
